import { render } from "./appError.vue?vue&type=template&id=4e6b67aa&scoped=true"
import script from "./appError.vue?vue&type=script&lang=js"
export * from "./appError.vue?vue&type=script&lang=js"

import "./appError.vue?vue&type=style&index=0&id=4e6b67aa&lang=scss"
import "./appError.vue?vue&type=style&index=1&id=4e6b67aa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3462219866/src/github.com/visitorscoverage/vc-code/vue/apps/benefit-estimator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6b67aa"]])

export default __exports__